import React from 'react';
import { getHandler } from '@udecode/plate';
import { useFocused, useSelected } from 'slate-react';
import { Text } from '@noom/wax-component-library';
export const MentionInput = (props) => {
    const { attributes, children, nodeProps, element, onClick } = props;
    const selected = useSelected();
    const focused = useFocused();
    const styles = {
        paddingY: 0.2,
        pr: 1,
        borderRadius: 'md',
        shadow: selected && focused ? 'outline' : undefined,
        zIndex: 'sticky',
        display: 'inline-block',
    };
    return (React.createElement(Text, Object.assign({}, attributes, { "data-slate-value": element.value, onClick: getHandler(onClick, element), position: "relative" }, styles, nodeProps),
        element.trigger,
        children));
};
//# sourceMappingURL=MentionInput.js.map